import { render } from "./InformationContent.vue?vue&type=template&id=58df4242"
import script from "./InformationContent.vue?vue&type=script&lang=js"
export * from "./InformationContent.vue?vue&type=script&lang=js"

import "./InformationContent.vue?vue&type=style&index=0&id=58df4242&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__